import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import NavBar from "@/components/NavBar";
import AuthCallback from "@/components/AuthCallback";
import CallsignSetup from "@/components/CallsignSetup";
import Home from "@/pages/Home";
import Practice from "@/pages/Practice";
import Library from "@/pages/Library";
import Stats from "@/pages/Stats";
import LeaderboardPage from "@/pages/Leaderboard";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import VerifyEmail from "@/pages/VerifyEmail";
import ResetPassword from "@/pages/ResetPassword";
import NotFound from "@/pages/NotFound";
import { StratagemProvider } from "@/context/StratagemContext";
import { AuthProvider } from "@/context/AuthContext";

function AppRouter() {
  const location = useLocation();

  // CRITICAL: Detect session_id synchronously during render (not in useEffect)
  // This prevents race conditions with auth checks
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      <NavBar />
      <main className="flex-1" data-testid="app-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/practice" element={<Practice />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/library" element={<Library />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify" element={<VerifyEmail />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <CallsignSetup />
      <footer
        className="border-t border-white/10 py-6 px-6 mt-12"
        data-testid="app-footer"
      >
        <div className="max-w-3xl mx-auto text-center">
          <a
            href="mailto:feedback@superstratagemtrainer.com?subject=Super%20Stratagem%20Trainer%20Feedback"
            className="inline-flex items-center gap-2 text-xs text-[#FFE800] hover:text-[#FFE800]/80 mb-4"
            data-testid="footer-feedback"
          >
            Send Feedback or Report an Issue
          </a>
          <p className="text-xs text-gray-500 leading-relaxed">
            Super Stratagem Trainer is not affiliated with, endorsed by, or
            sponsored by Arrowhead Game Studios or Sony Interactive
            Entertainment. All Helldivers 2 names, logos, stratagems, and related
            content are trademarks and property of their respective owners. This
            is an unofficial fan-made training tool.
          </p>
        </div>
      </footer>
    </>
  );
}

function App() {
  return (
    <div className="App relative text-white">
      <div className="crt-overlay" aria-hidden="true" />
      <div className="vignette" aria-hidden="true" />
      <div className="scanline" aria-hidden="true" />
      <AuthProvider>
        <StratagemProvider>
          <BrowserRouter>
            <div className="relative z-10 flex flex-col min-h-screen">
              <AppRouter />
            </div>
          </BrowserRouter>
          <Toaster
            richColors
            position="bottom-right"
            toastOptions={{
              className:
                "font-data bg-black text-[#FFE800] border border-[#FFE800]/40",
            }}
          />
        </StratagemProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
